// ============================================================
// KONFIGURASI PUSAT LANDING PAGE KalkuBisnis
// Ubah nilai di file ini saja — seluruh halaman mengikuti.
// ============================================================

// URL checkout Mayar asli — semua tombol beli di landing page menuju ke sini.
export const MAYAR_CHECKOUT_URL = "https://giatsukses.myr.id/pl/kalkubisnis";

// Harga (dalam Rupiah). Seluruh tampilan harga membaca dari sini.
export const PRICING = {
  REGULAR: 179000, // harga normal rencana — ditampilkan dicoret selama promo peluncuran aktif
  LAUNCH: 129000, // harga spesial peluncuran
};
export const SAVING = PRICING.REGULAR - PRICING.LAUNCH; // Hemat Rp50.000
// Set ke false untuk menyembunyikan harga coret & badge hemat (promo berakhir).
export const LAUNCH_PROMO_ACTIVE = true;

// URL video panduan (YouTube/dll). Kosong = thumbnail menampilkan pemberitahuan.
export const TUTORIAL_VIDEO_URL = "https://youtu.be/GJHD52K5NfQ";

// Domain produksi untuk canonical/OG. Isi setelah domain final, mis. "https://kalkubisnis.id".
// Kosong = tag canonical & og:url tidak dirender (aman untuk SEO).
export const SITE_URL = "";

export const formatIDR = (n) => "Rp" + n.toLocaleString("id-ID");

// Teks persetujuan — juga dipakai di dekat tombol beli.
// SALIN teks di bawah ini ke deskripsi produk / catatan checkout Mayar secara manual:
export const MAYAR_CONSENT_NOTICE =
  "Dengan melanjutkan pembelian, kamu menyatakan telah membaca dan menyetujui Syarat dan Ketentuan KalkuBisnis.";
